"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[482],{

/***/ 577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6737);
/* harmony import */ var sweetalert__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(sweetalert__WEBPACK_IMPORTED_MODULE_0__);

var ResponseErrorServerSide = function(err) {
    if (err.response) {
        var ref, ref1;
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()((ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message, "", "error");
    } else if (err.request) {
        // The request was made but no response was received
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()("Error Occured. Please Try Again Later!", "", "error");
    } else {
        // Something happened in setting up the request that triggered an Error
        sweetalert__WEBPACK_IMPORTED_MODULE_0___default()("Error Occured. Please Try Again Later!", "", "error");
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponseErrorServerSide);


/***/ }),

/***/ 8588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TV": function() { return /* reexport */ blogs_CustomHero; },
  "VM": function() { return /* reexport */ Detail_Hero; },
  "ob": function() { return /* reexport */ blogs_Items; },
  "aV": function() { return /* reexport */ Detail_List; },
  "tl": function() { return /* reexport */ blogs_Pagination; },
  "Qg": function() { return /* reexport */ Detail_RecentPost; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@coreui/react/dist/index.es.js
var index_es = __webpack_require__(4475);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/colors.js
var colors = __webpack_require__(3990);
;// CONCATENATED MODULE: ./parts/blogs/Items/index.js
/* eslint-disable react/prop-types */ 




function Items(param) {
    var data = param.data, language = param.language, currentPage = param.currentPage, pageSize = param.pageSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "content mb-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-our-office-location",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CRow */.rb, {
                            children: (data === null || data === void 0 ? void 0 : data.length) > 0 ? data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCol */.b7, {
                                    md: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: language === "EN" ? item.en_slug ? "/blogs/detail/" + item.en_slug : "#" : item.id_slug ? "/blogs/detail/" + item.id_slug : "#",
                                        locale: language === "ID" ? "id" : "en",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CCard */.xH, {
                                                className: "col-contents-box-blogs",
                                                style: {
                                                    // width: '350px',
                                                    // boxShadow: `0px 0px 15px gray`,
                                                    marginBottom: "50px",
                                                    borderTopLeftRadius: "12px !important",
                                                    borderTopRightRadius: "12px !important"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardImage */.pX, {
                                                        className: "image-blogs",
                                                        style: {
                                                            borderTopLeftRadius: "12px !important",
                                                            borderTopRightRadius: "12px !important"
                                                        },
                                                        height: "300",
                                                        orientation: "top",
                                                        src: language === "EN" ? item.en_featured_img : item.id_featured_img
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CCardBody */.sl, {
                                                        className: "card-body card-body-blogs",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* CCardSubtitle */.a1, {
                                                                className: "mb-2 text-medium-emphasis",
                                                                children: [
                                                                    "Posted On ",
                                                                    item.publishedAt || "-"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardTitle */.tj, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: language === "EN" ? item.en_title : item.id_title
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CCardText */.uS, {
                                                                dangerouslySetInnerHTML: {
                                                                    __html: language === "EN" ? item.en_meta_content : item.id_meta_content
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }, index);
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fw-semibold fs-4",
                                        style: {
                                            color: colors/* default.blue1 */.Z.blue1,
                                            letterSpacing: "0.1px"
                                        },
                                        children: "There are no post yet"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "fw-light",
                                        style: {
                                            color: colors/* default.blue1 */.Z.blue1
                                        },
                                        children: "New post will show up here"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex justify-content-end mt-3",
                            children: (data === null || data === void 0 ? void 0 : data.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(blogs_Pagination, {
                                currentPage: currentPage,
                                pageCount: pageSize,
                                language: language
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var blogs_Items = (Items);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./parts/blogs/Pagination/index.js
/* eslint-disable */ /* eslint-disable react/prop-types */ 



var Pagination = function(param) {
    var currentPage = param.currentPage, pageCount = param.pageCount, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPagination */.E7, {
        className: "mb-0",
        children: currentPage === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: currentPage === 1 && pageCount === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                        disabled: true,
                        children: "Previous"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                        active: true,
                        children: currentPage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                        disabled: true,
                        children: "Next"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                        disabled: true,
                        children: "Previous"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                        active: true,
                        children: currentPage
                    }),
                    pageCount === currentPage + 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blogs?currentPage=".concat(currentPage + 1),
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                                        children: currentPage + 1
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blogs?currentPage=".concat(currentPage + 1),
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                                        children: "Next"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blogs?currentPage=".concat(currentPage + 1),
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                                        children: currentPage + 1
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blogs?currentPage=".concat(currentPage + 2),
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                                        children: currentPage + 2
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blogs?currentPage=".concat(currentPage + 1),
                                locale: language === "ID" ? "id" : "en",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                                        children: "Next"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/blogs?currentPage=".concat(currentPage - 1),
                    locale: language === "ID" ? "id" : "en",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                            children: "Previous"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/blogs?currentPage=".concat(currentPage - 1),
                    locale: language === "ID" ? "id" : "en",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                            children: currentPage - 1
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                    active: true,
                    children: currentPage
                }),
                currentPage !== pageCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/blogs?currentPage=".concat(currentPage + 1),
                            locale: language === "ID" ? "id" : "en",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                                    children: currentPage + 1
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/blogs?currentPage=".concat(currentPage + 1),
                            locale: language === "ID" ? "id" : "en",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                                    children: "Next"
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* CPaginationItem */.tn, {
                        disabled: true,
                        children: "Next"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var blogs_Pagination = (Pagination);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./parts/blogs/Detail/Hero/index.js
/* eslint-disable */ /* eslint-disable @next/next/no-img-element */ 



function Hero(param) {
    var language = param.language, _dataHeader = param.dataHeader, dataHeader = _dataHeader === void 0 ? {} : _dataHeader, breadcrump = param.breadcrump, title = param.title;
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath.split("/").pop();
    var ref = (0,react.useState)(""), breadcumbParentEn = ref[0], setBreadcumbParentEn = ref[1];
    var ref1 = (0,react.useState)(""), breadcumbParentId = ref1[0], setBreadcumbParentId = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        breadcrump === null || breadcrump === void 0 ? void 0 : (ref = breadcrump.HeaderMenus) === null || ref === void 0 ? void 0 : ref.forEach(function(item) {
            var ref;
            item === null || item === void 0 ? void 0 : (ref = item.child) === null || ref === void 0 ? void 0 : ref.forEach(function(secondItem) {
                // validate if parent 2 have url (page)
                if (((secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("id_url")) || (secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("en_url"))) && ("blogs" === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.id_url) || "blogs" === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.en_url))) {
                    setBreadcumbParentEn(item.en_menu_name);
                    setBreadcumbParentId(item.id_menu_name);
                }
            });
        });
    }, [
        dataHeader
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "top-page-detail",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-in-area",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                    className: "breadcrumb",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            locale: language === "ID" ? "id" : "en",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                style: {
                                    cursor: "pointer"
                                },
                                children: "Home"
                            })
                        }),
                        language === "EN" && breadcumbParentEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: breadcumbParentEn
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        language === "ID" && breadcumbParentId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: breadcumbParentId
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/blogs",
                                locale: language === "ID" ? "id" : "en",
                                children: language === "EN" ? dataHeader.en_parent_title : dataHeader.id_parent_title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: title
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var Detail_Hero = (Hero);

// EXTERNAL MODULE: ./components/index.js + 23 modules
var components = __webpack_require__(9765);
;// CONCATENATED MODULE: ./parts/blogs/CustomHero/index.js
/* eslint-disable */ /* eslint-disable no-prototype-builtins */ /* eslint-disable @next/next/no-img-element */ 




function CustomHero(param) {
    var language = param.language, _dataHeader = param.dataHeader, dataHeader = _dataHeader === void 0 ? {} : _dataHeader, breadcrump = param.breadcrump;
    var router = (0,next_router.useRouter)();
    // karena email (as contact-us) di dalem free consultan
    var idFreeConsultan = 20;
    // ambil url terakhir
    var pathname = router.asPath.split("/").pop();
    // breadcrump yang nampil (parent ke 3)
    var ref = (0,react.useState)(""), breadcumbEn = ref[0], setBreadcumbEn = ref[1];
    var ref1 = (0,react.useState)(""), breadcumbId = ref1[0], setBreadcumbId = ref1[1];
    // url untuk validasi (parent ke 3)
    var ref2 = (0,react.useState)(""), breadcumbEnUrl = ref2[0], setBreadcumbEnUrl = ref2[1];
    var ref3 = (0,react.useState)(""), breadcumbIdUrl = ref3[0], setBreadcumbIdUrl = ref3[1];
    // breadcrump parent ke 2
    var ref4 = (0,react.useState)(""), breadcumbParentEn = ref4[0], setBreadcumbParentEn = ref4[1];
    var ref5 = (0,react.useState)(""), breadcumbParentId = ref5[0], setBreadcumbParentId = ref5[1];
    (0,react.useEffect)(function() {
        var // keterangan
        // parent 1 = home
        // ini buat ambil parent ke 2 dan 3
        ref;
        breadcrump === null || breadcrump === void 0 ? void 0 : (ref = breadcrump.HeaderMenus) === null || ref === void 0 ? void 0 : ref.forEach(function(item) {
            if ((item === null || item === void 0 ? void 0 : item.hasOwnProperty("child")) && (item === null || item === void 0 ? void 0 : item.id) !== idFreeConsultan) {
                var ref;
                item === null || item === void 0 ? void 0 : (ref = item.child) === null || ref === void 0 ? void 0 : ref.forEach(function(secondItem) {
                    // validate if parent 2 have url (page)
                    if (((secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("id_url")) || (secondItem === null || secondItem === void 0 ? void 0 : secondItem.hasOwnProperty("en_url"))) && (pathname === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.id_url) || pathname === (secondItem === null || secondItem === void 0 ? void 0 : secondItem.en_url))) {
                        setBreadcumbParentEn(item.en_menu_name);
                        setBreadcumbParentId(item.id_menu_name);
                    // if have parent 3
                    } else {
                        var ref;
                        secondItem === null || secondItem === void 0 ? void 0 : (ref = secondItem.child) === null || ref === void 0 ? void 0 : ref.forEach(function(thirdItem) {
                            if (thirdItem.en_url === pathname && language === "EN") {
                                setBreadcumbEnUrl(secondItem.en_url);
                                setBreadcumbIdUrl(secondItem.id_url);
                                setBreadcumbEn(secondItem.en_menu_name);
                                setBreadcumbId(secondItem.id_menu_name);
                                setBreadcumbParentEn(item.en_menu_name);
                                setBreadcumbParentId(item.id_menu_name);
                            }
                            if (thirdItem.id_url === pathname && language === "ID") {
                                setBreadcumbEnUrl(secondItem.en_url);
                                setBreadcumbIdUrl(secondItem.id_url);
                                setBreadcumbEn(secondItem.en_menu_name);
                                setBreadcumbId(secondItem.id_menu_name);
                                setBreadcumbParentEn(item.en_menu_name);
                                setBreadcumbParentId(item.id_menu_name);
                            }
                        });
                    }
                });
            }
        });
    }, [
        dataHeader
    ]);
    var handleClick = function(url) {
        if (url !== "#") window.open(url, // "https://wa.me/0831?text=oke",
        "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "top-page-courier-service top-page-cs-air-freight",
        style: {
            backgroundImage: "url(" + (dataHeader === null || dataHeader === void 0 ? void 0 : dataHeader.banner_img) + ")"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "page-bg-overlay"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-in-area",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                className: "breadcrumb",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "Home"
                                            })
                                        })
                                    }),
                                    language === "EN" && breadcumbParentEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbParentEn
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    language === "ID" && breadcumbParentId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbParentId
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    language === "EN" && breadcumbEn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbEnUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/" + breadcumbEnUrl,
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: breadcumbEn
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: breadcumbEn
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    language === "ID" && breadcumbId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: breadcumbIdUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/" + breadcumbIdUrl,
                                            locale: language === "ID" ? "id" : "en",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: breadcumbId
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: breadcumbId
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "active",
                                        children: language === "EN" ? dataHeader.en_title : dataHeader.id_title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "title",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? dataHeader.en_title : dataHeader.id_title
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "subtitle",
                                dangerouslySetInnerHTML: {
                                    __html: language === "EN" ? dataHeader.en_desc : dataHeader.id_desc
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ScrollNav */.IO, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var blogs_CustomHero = (CustomHero);

// EXTERNAL MODULE: ./node_modules/base-64/base64.js
var base64 = __webpack_require__(7501);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./parts/blogs/Detail/List/index.js
/* eslint-disable */ /* eslint-disable @next/next/no-img-element */ 




function List(param) {
    var data = param.data, _dataHeader = param.dataHeader, dataHeader = _dataHeader === void 0 ? {} : _dataHeader, language = param.language;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath.split("/").pop();
    var handleClick = function(url) {
        if (url !== "#") window.open(url, // "https://wa.me/0831?text=oke",
        "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: "image-blogs-detail",
                    src: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_featured_img : data === null || data === void 0 ? void 0 : data.id_featured_img,
                    alt: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_alt_featured_img : data === null || data === void 0 ? void 0 : data.id_alt_featured_img,
                    width: 730,
                    height: 350
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                style: {
                    marginTop: "36px",
                    marginBottom: "25px"
                },
                className: "mb-5",
                dangerouslySetInnerHTML: {
                    __html: language === "EN" ? data === null || data === void 0 ? void 0 : data.en_title : data === null || data === void 0 ? void 0 : data.id_title
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Posted On",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: data === null || data === void 0 ? void 0 : data.publishedAt
                        }
                    })
                ]
            }),
            language === "EN" && (data === null || data === void 0 ? void 0 : data.en_content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginTop: "5px",
                    marginBottom: "30px"
                },
                dangerouslySetInnerHTML: {
                    __html: decodeURIComponent(escape((0,base64.decode)(data.en_content)))
                }
            }),
            language === "ID" && (data === null || data === void 0 ? void 0 : data.id_content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginTop: "5px",
                    marginBottom: "30px"
                },
                dangerouslySetInnerHTML: {
                    __html: decodeURIComponent(escape((0,base64.decode)(data.id_content)))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-btn-talk col-btn-talk-blog",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "btn-talk btn-cta-detail",
                    style: {
                        backgroundColor: dataHeader === null || dataHeader === void 0 ? void 0 : (ref = dataHeader.headerCTA) === null || ref === void 0 ? void 0 : ref.bg_color
                    },
                    onClick: function() {
                        var ref;
                        return handleClick(dataHeader === null || dataHeader === void 0 ? void 0 : (ref = dataHeader.headerCTA) === null || ref === void 0 ? void 0 : ref.url);
                    },
                    type: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 20,
                            height: 20,
                            src: dataHeader === null || dataHeader === void 0 ? void 0 : (ref1 = dataHeader.headerCTA) === null || ref1 === void 0 ? void 0 : ref1.icon,
                            alt: dataHeader === null || dataHeader === void 0 ? void 0 : (ref2 = dataHeader.headerCTA) === null || ref2 === void 0 ? void 0 : ref2.alt_icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: language === "EN" ? dataHeader === null || dataHeader === void 0 ? void 0 : (ref3 = dataHeader.headerCTA) === null || ref3 === void 0 ? void 0 : ref3.en_name : dataHeader === null || dataHeader === void 0 ? void 0 : (ref4 = dataHeader.headerCTA) === null || ref4 === void 0 ? void 0 : ref4.id_name
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    marginBottom: "30px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                    children: [
                        "Tags:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: data === null || data === void 0 ? void 0 : data.tag
                            }
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var Detail_List = (List);

;// CONCATENATED MODULE: ./parts/blogs/Detail/RecentPost/index.js
/* eslint-disable */ 





function RecentPost(param) {
    var data = param.data, language = param.language;
    var router = (0,next_router.useRouter)();
    var pathname = router.asPath.split("/");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            background: colors/* default.blue1 */.Z.blue1,
            borderRadius: "15px",
            padding: "17px 22px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    color: "white",
                    fontWeight: "600"
                },
                children: language === "EN" ? "Recent Post" : "Posting Terbaru"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginTop: "5px"
                },
                children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: language === "EN" ? item.en_slug && "/" + "blogs/detail/" + item.en_slug : item.id_slug && "/" + "blogs/detail/" + item.id_slug,
                        locale: language === "ID" ? "id" : "en",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "m-0 recent-post-details",
                            style: {
                                color: "white",
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        fontWeight: "600"
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: language === "EN" ? item.en_title : item.id_title
                                    }
                                })
                            })
                        }, index)
                    });
                })
            })
        ]
    });
}
/* harmony default export */ var Detail_RecentPost = (RecentPost);

;// CONCATENATED MODULE: ./parts/blogs/index.js









/***/ }),

/***/ 5267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ courier_services_NavbarCourierServices; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 12 modules
var es = __webpack_require__(1894);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./parts/courier-services/NavbarCourierServices/index.js
/* eslint-disable no-unused-vars */ /* eslint-disable no-prototype-builtins */ /* eslint-disable @next/next/no-img-element */ 




function NavbarCourierServices(param) {
    var topFunction = param.topFunction, data = param.data, changeLanguage = param.changeLanguage, language = param.language;
    // buat misahin posisi menu navbar
    var idFreeConsultation = 20;
    // buat conditional routing per id detail
    var idCourier = 2;
    var idInternational = 7;
    // buat redirect ke luar web
    var idEmail = 22;
    var handleClickFreeConsul = function(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                locale: language === "ID" ? "id" : "en",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: data === null || data === void 0 ? void 0 : data.logo,
                        alt: data === null || data === void 0 ? void 0 : data.alt_logo,
                        // layout="fill"
                        width: 125,
                        height: 62
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "top-nav-menu",
                children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                    return item.id !== idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: item.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        child.hasOwnProperty("id_url") || child.hasOwnProperty("en_url") ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                            locale: language === "ID" ? "id" : "en",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        }),
                                                        child.hasOwnProperty("child") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "subs-nav",
                                                                children: child.child.map(function(childofchild, childofchildIndex) {
                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: (child === null || child === void 0 ? void 0 : child.id) === idCourier ? "/courier-services/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : child.id === idInternational ? "/international-delivery/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url) : "/supply-chain/".concat(language === "EN" ? childofchild === null || childofchild === void 0 ? void 0 : childofchild.en_url : childofchild === null || childofchild === void 0 ? void 0 : childofchild.id_url),
                                                                                locale: language === "ID" ? "id" : "en",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    children: language === "ID" ? childofchild.id_menu_name : childofchild.en_menu_name
                                                                                })
                                                                            })
                                                                        }, childofchildIndex)
                                                                    });
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    ]
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index)
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: language === "ID" ? "/" + (item === null || item === void 0 ? void 0 : item.id_url) : "/" + (item === null || item === void 0 ? void 0 : item.en_url),
                                    locale: language === "ID" ? "id" : "en",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: language === "ID" ? item.id_menu_name : item.en_menu_name
                                    })
                                })
                            })
                        })
                    });
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "right",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu top-consultation",
                        children: (data === null || data === void 0 ? void 0 : data.HeaderMenus) !== undefined && (data === null || data === void 0 ? void 0 : data.HeaderMenus.map(function(item, index) {
                            return item.id === idFreeConsultation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "link-sub-nav",
                                        children: language === "EN" ? item.en_menu_name : item.id_menu_name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "sub-nav-content",
                                        children: item.child.map(function(child, childIndex) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: (child === null || child === void 0 ? void 0 : child.id) === idEmail ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: language === "ID" ? "/" + (child === null || child === void 0 ? void 0 : child.id_url) : "/" + (child === null || child === void 0 ? void 0 : child.en_url),
                                                        locale: language === "ID" ? "id" : "en",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                        })
                                                    })
                                                }, childIndex) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    onClick: function() {
                                                        return handleClickFreeConsul(language === "EN" ? child.en_url : child.id_url);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "link-sub-nav",
                                                        children: language === "ID" ? child.id_menu_name : child.en_menu_name
                                                    })
                                                }, childIndex)
                                            });
                                        })
                                    })
                                ]
                            }, index);
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "top-nav-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/globe.png"),
                                            width: 39,
                                            height: 30,
                                            alt: "ckl-logo"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-language",
                                            children: language
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "sub-nav-content",
                                    children: [
                                        language === "ID" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "EN"
                                            })
                                        }),
                                        language === "EN" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            onClick: changeLanguage,
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "ID"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "home",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: topFunction,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat("https://cklnext.lyrid.id/", "/assets/icons/home.png"),
                            width: 39,
                            height: 30,
                            alt: "home"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var courier_services_NavbarCourierServices = (NavbarCourierServices);

;// CONCATENATED MODULE: ./parts/courier-services/index.js




/***/ })

}]);